"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _reactRouter = require("react-router");

var _Enrollment = _interopRequireDefault(require("./Enrollment"));

var _reactRouterDom = require("react-router-dom");

var _Dropout = _interopRequireDefault(require("./Dropout"));

var TabPane = _antd.Tabs.TabPane;

var New = function New() {
  var history = (0, _reactRouter.useHistory)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Tabs, {
    type: "card",
    onChange: function onChange(key) {
      history.push("/clPortal/app/parent/requests/history/".concat(key));
    }
  }, /*#__PURE__*/_react.default.createElement(TabPane, {
    tab: "Enrollment history",
    key: "enroll"
  }, /*#__PURE__*/_react.default.createElement(_Enrollment.default, null)), /*#__PURE__*/_react.default.createElement(TabPane, {
    tab: "DropOut history",
    key: "drop"
  }, /*#__PURE__*/_react.default.createElement(_Dropout.default, null))));
};

var _default = New;
exports.default = _default;